import React, { useState } from "react";
import RequestService from "../../services/request.service";

import { Button, Modal, Table, Form, Tabs, Tab } from 'react-bootstrap'


import { toast } from 'react-toastify'

import Dialog from '../../services/Dialogs'

import moment from 'moment'

import Pagination from "../../services/Pagination";



import EditarTramite from '../Mesa_Atencion/editarTramite'


import AuthService from '../../features/auth/auth.service'

import { SERVER_ } from  '../../config';


import ModalFichaTramite from './ModalFichaTramite'



const formatCurrency = (number:number) => {
  return '$' + number.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}




const MisTramites = () =>{

    const User = AuthService.getCurrentUser()

    const dialog = new Dialog();


    const [allSessionsCount,setCounter] = useState(0);
    const sessionsPerPage = 50
    const [currentPage, setCurrentPage] = useState(1);

    const [ pagina, setPagina ] = useState(0)
    const [ text_busqueda, setTextoBusqueda ] = useState('')

    const [ cargando_, setCargando ] = useState( false )

  const [ tramites, setReporte ] = useState<any>([])

  const cargarMiReporte = async(page:number)=>{
    try{
      setCargando(true)
      let skip = 0
      if(page===0) skip = 0; else skip = (page*10);
      let response : any = await RequestService.getEndPoint('mis_tramites/'+arreglo_estatus+'?where='+text_busqueda+'&skip='+skip)
      // console.log(response.data)
      setPagina(page)
      // setTotalResulados(response.data.totalCount)
      setCounter(response.data.totalCount)
      // setPaginas(response.data.numberPages)

      setReporte(response.data.tramites)
      setCargando(false)
      // toast.success('La lista de Tramites del día '+fecha+' fue cargada')
    }
    catch(e){
      setCargando(false)
      toast.error('Problemas al intentar generar tus tramitems. Contacta con los administradores del sistema')
    }
  }

  const [ arreglo_estatus, setEstatus ] = useState<any>([true,true,true,true,true,true,true,true,true,true])


  const busqueda = async () =>{
    setPagina(0)
    cargarMiReporte(0)
    setCurrentPage(1)
  }


  const todos = () =>{
    setEstatus([true,true,true,true,true,true,true,true,true,true])
  }
  const ninguno = () =>{
    setEstatus([false,false,false,false,false,false,false,false,false,false])
  }




  const enviarVerificacion = async (e:any,uuid:string) =>{
    try{
      
        await dialog.open({
          accept: 'Aceptar',
          dialogClass: '',
          message: 'Enviar a verificación',
          target: e.target,
          template: `<p>¿Estás seguro de enviar este trámite a su verificación en Mesa de Trabajo?</p>`
        })
        let dialogo : any = await dialog.waitForUser()


      if(dialogo){
          await RequestService.update('tramite/enviar_verificacion/'+uuid,{})
          toast.success('En espera de verificación de mesa de atención')
          cargarMiReporte(0)
      }



    }
    catch(e){
      toast.error('Problemas para enviar a verificación')
    }
  }




  const [ showModalDetalleCobranza, setShowModalDetalleCobranza ] = useState<any>(false)

  const onHideModalDetalleCobranza = () => {
    setShowModalDetalleCobranza(false)
    // setUUIDTramiteSeleccionado(uuid_tramite)
  }

            
  const detalleCobranza = (uuid_tramite:string)=>{
    setShowModalDetalleCobranza(true)
      setEdit_uuid_tramite(uuid_tramite)
  }


  const [ uuid_tramite , setEdit_uuid_tramite ] = useState("")

  const [showRectificarModal, setShowRectificarModal] = useState(false);




  const handleCloseRectificarModal = async(e:any) =>{ 
    try{
      // setShowRectificarModal(false)
      // await enviarVerificacion(e,uuid_tramite)
      if(await dialog.confirm('¿Estás seguro de enviar a verificación?',{})){
          await RequestService.update('tramite/enviar_verificacion/'+uuid_tramite,{})
          toast.success('En espera de verificación de mesa de atención')
          cargarMiReporte(0)
          setShowRectificarModal(false)
      }
      
    }
    catch(e){
      toast.error('Error al cambiar de estatus el tramite')
    }
  }
  const handleShowRectificarModal = async (uuid_tramite:string) =>{ 
        await cargarComentarios(uuid_tramite)
        setEdit_uuid_tramite(uuid_tramite)
        setShowRectificarModal(true);
  }



  const [ anexos_tramite_seleccionado, setAnexosSeleccionados ] = useState<any>({
    anexos_digitales : [],
    anexos_por_subir : []
  })

  const [showModalAnexos, setModalAnexos ] = useState(false)

  const handleModalAnexosClose = () => {
    setModalAnexos(false)
  }

  const [ tramite_seleccionado, setTramiteSeleccion ] = useState<any>({})

  const handleModalAnexosShow = async (tramite:any) => {
    try{
      // console.log(tramite)
      setTramiteSeleccion(tramite)
      let req = await RequestService.getEndPoint('anexos_digitales/'+tramite.uuid_tramite)
      // console.log(req.data)
      setAnexosSeleccionados(req.data)
      setModalAnexos(true)
    }
    catch(e){
      setModalAnexos(false)
      toast.error('Error al cargar los anexos')
    }
  }





  const [ showEditarTramite , setShowEditarTramite ] = useState(false)
  const [ data_tramite, setDataTramiteEdit ] = useState<any>({nombres:"",paterno:"",materno:"",folio:"",monto:0})
  const [ departamento_edicion, setDepartamentoEdicion ] = useState<any>({})

  const editarTramite = async (event, uuid:string) => {
    try{
      setEdit_uuid_tramite(uuid)
      setShowEditarTramite(true)
      let response = await RequestService.getEndPoint('data-tramimte/'+uuid)
      // console.log(response.data)
      let formTramite : any = {
        nombres : response.data.idciudadano.nombres,
        paterno : response.data.idciudadano.paterno,
        materno : response.data.idciudadano.materno,
        sexo : response.data.idciudadano.sexo,

        folio : response.data.folio,

        curp : response.data.idciudadano.curp,
        seguro_social : response.data.idciudadano.seguro_social,

        direccion : response.data.idciudadano.direccion?response.data.idciudadano.direccion:'',
        colonia : response.data.idciudadano.colonia?response.data.idciudadano.colonia:'',
        cp : response.data.idciudadano.cp?response.data.idciudadano.cp:'',

        celular : response.data.idciudadano.celular?response.data.idciudadano.celular:'',
        telefono : response.data.idciudadano.telefono?response.data.idciudadano.telefono:'',
        email : response.data.idciudadano.email?response.data.idciudadano.email:'',

        fecha_baja_anterior : moment(response.data.depto_estrategias.fecha_baja_anterior, 'YYYY-MM-DD').toDate(),
        fecha_alta_anterior : moment(response.data.depto_estrategias.fecha_alta_anterior, 'YYYY-MM-DD').toDate(),
        traspaso_afore : response.data.depto_estrategias.traspaso_afore,
        idafore : response.data.depto_estrategias.idafore,
        idafore_anterior : response.data.depto_estrategias.idafore_anterior,
        semanas_cotizadas : response.data.depto_estrategias.semanas_cotizadas,
        sueldo_trabajador : response.data.depto_estrategias.sueldo_trabajador,
        monto_rcv : response.data.depto_estrategias.monto_rcv,
        monto_aseguramiento : response.data.depto_estrategias.monto_aseguramiento,
        anticipo : response.data.depto_estrategias.anticipo,
        // monto : response.data.monto,


        // sindo : moment(response.data.depto_estrategias.sindo, 'YYYY-MM-DD').toDate(),
        sindo : null,


        anexos_digitales : response.data.anexos_digitales

        // monto : response.data.monto,
        // monto : response.data.monto,
        // monto : response.data.monto,
        // monto : response.data.monto,
          // : yup.string(),
          // : yup.string().matches( REG_NOMBRES , "Formato de nombre no valido").required('El nombre es obligatorio'),
          // : yup.string().matches( REG_NOMBRES , "Formato de nombre no valido").required('El primer apellido es obligatorio'),
          // : yup.string().matches( REG_NOMBRES , "Formato de nombre no valido"),
          // : yup.string().matches( REG_CURP , "Formato de CURP invalido").required('El CURP es un campo obligatorio'),
          // : yup.number().required('Debes ingresar un monto'),

      }
      console.log(formTramite)

      if(response.data.depto_estrategias.sindo){
        formTramite.sindo = moment(response.data.depto_estrategias.sindo, 'YYYY-MM-DD').toDate()
      }

      setDepartamentoEdicion(response.data.iddepartamento)
      setDataTramiteEdit(formTramite)
    }
    catch(e){
      toast.error('Tuvimos un error')
    }

  }

  const handleCloseEditarTramite = ()=>{
      setShowEditarTramite(false)
      cargarMiReporte(0)
  }




  const [ comments, setComments ] = useState({
    resuelto_todo : false,
    comments : []
  })

  const cargarComentarios = async (uuid_tramite:string) =>{
      try{
        let response = await RequestService.getEndPoint('tramite/comentarios_atencion/'+uuid_tramite)
        setComments(response.data)
      }
      catch(e){
        toast.error('Error al cargar los comentarios')
      }
  }





  const borrarTramite = async (event,uuid:string) => { 
    try{


  dialog.open({
    accept: 'Si, eliminar',
    cancel: 'Cancelar',
    dialogClass: 'custom_danger',
    message: '¿Estás seguro? ',
    target: event.target,
    template: `
  <h4 className="alert-heading">¡ESPERA!</h4>
  <p className="mb-0">Se perderán los cambios</p>
    `
  })
  // console.log( await dialog.waitForUser() ) //.then((res) => {  console.log(res) })
        if ( await dialog.waitForUser() ) {
          // console.log('=')
            await RequestService.delete('tramite/'+uuid)
            toast.warning('Borraste algo. Espero que sepas lo que estas haciendo.')
            cargarMiReporte(0)
        }
        else{
          console.log('+')
        }

    }
    catch(e){
      toast.error('Ups! Error al intentar borrar el tramite')
    }
  }




  const comentarioAtendido = async(uuid_comentario:string)=>{
    try{
      if(await dialog.confirm('¿Quieres marcar como atendido?',{})){
        await RequestService.update('tramites/comentario_atencion/'+uuid_comentario,{})
        await cargarComentarios(uuid_tramite)
      }
    }
    catch(e){
      toast.error('Error al cambiar el estatus del comentario')
    }
  }


const [key, setKey] = useState<any>('home');


const [ anexo_visualizar, setAnexoVisualizar ] = useState<string>('')
const [ anexo_para_subir, setAnexoSubir ] = useState<string>('')
const [ anexo_archivo_subir, setArchivoSubir ] = useState<any>('')

const setAnexoVer = (anexo:string)=>{
  setAnexoVisualizar(anexo)
}

  const handleFileRead = async (event:any) => {
    const file = event.target.files[0]
    const base64 = await convertBase64(file)
    setArchivoSubir(base64)
  }


  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file)
      fileReader.onload = () => {
        resolve(fileReader.result);
      }
      fileReader.onerror = (error) => {
        reject(error);
      }
    })
  }


  const agregarNuevoAnexo = async () =>{
    try{
        if(await dialog.confirm('¿Estás seguro?',{})){
        let req = await  RequestService.update('tramite/subir_anexo/'+tramite_seleccionado.uuid_tramite, { uuid_requisito : anexo_para_subir, documento : anexo_archivo_subir})

        setAnexoVisualizar('')
        setAnexoSubir('')
        setArchivoSubir('')
          let req2 = await RequestService.getEndPoint('anexos_digitales/'+tramite_seleccionado.uuid_tramite)
          // console.log(req.data)
          setAnexosSeleccionados(req2.data)
          toast.success('Tu anexo se subio correctamente')
      }
    }
    catch(e){toast.error('Error')}
  }


  const eliminarAnexo = async (uuid:string) =>{
    try{
        if (await dialog.confirm( '¿Estas seguro?', {} )) {
        await RequestService.delete('eliminar-anexo-tramite/'+uuid)
        // cargarMiReporte(fecha)
        let req = await RequestService.getEndPoint('anexos_digitales/'+tramite_seleccionado.uuid_tramite)
        setAnexoVisualizar('')
        // console.log(req.data)
        setAnexosSeleccionados(req.data)

        toast.warning('Borraste un anexo. Espero que sepas lo que haces')
      }

    }
    catch(e){
      setCargando(false)
      toast.error('No pudimos agregar el anexo digital. Comunicate con el administrador.')
    }  
  }




  const [ fechas_tramites_pendientes, setFechasTramitesPendientes ] = useState<any>([])

  const [showPendientesModal, setShowPendientesModal ] = useState(false);

  const handleClosePendientesModal = () => setShowPendientesModal(false);
  const handleShowPendientesModal = async () =>{
    try{
      let res = await RequestService.getEndPoint('mis_pendientes')
      setFechasTramitesPendientes(res.data)
      setShowPendientesModal(true);
    }
    catch(E){
      toast.error(JSON.stringify(E))
    }
    
  }



  const irAFecha = (fecha:string) => {
      // setFecha( moment(fecha).format('YYYY-MM-DD') )
      // cargarMiReporte(fecha)
      // setShowPendientesModal(false);
  }


  const [ showCobranza, setCobranzaModal ] = useState<boolean>(false)
  const [ tramites_cobranza, setTramitesCobranza ] = useState<any>([])

  const handleShowCobranzaModal = async () => {
    try{
      let res = await RequestService.getEndPoint('mi-reporte/tramites/cobranza')
      setTramitesCobranza(res.data)
      setCobranzaModal(true)
    }
    catch(e){
      toast.error('Erro al cargar la cobranza')
    }

  }

  const handleCloseCobranzaModal = () => setCobranzaModal(false)







  const [ show_ModalFichaTramite, setModalFichaTramite ] = useState<boolean>(false)
  const handleShow_ModalFichaTramite = (tramite:any) => {
    setTramiteSeleccion(tramite)
    setModalFichaTramite(true)
  }
  const handleClose_ModalFichaTramite = () => {
    setModalFichaTramite(false)
  }




      return (
          <>

            <div className="container">
              
              <h3>Mis Trámites</h3>

                              <div className="">
                                <label className="form-label">Búsqueda</label>
                                <div className="input-group mb-3">
                                  <input type="text" className="form-control" onKeyDown={(e)=>{if(e.keyCode === 13){ busqueda() }}} placeholder="" value={text_busqueda} onChange={event => setTextoBusqueda(event.target.value)} />
                                  <button onClick={busqueda} className="btn btn-default" type="button" id="button-addon2"><i className="fa fa-search" /></button>
                                </div>
                              </div>



              
              <div className="row">

                <div className="col-sm-12">
                  <small><b>Filtros</b></small>



                                      <div key={`inline-checkbox`} className="">

                                      {
                                        // JSON.stringify(arreglo_estatus)
                                      }

                                        <Form.Check inline name="group1" type="checkbox" label="CAPTURA" checked={arreglo_estatus[0]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[0] = e.target.checked;  setEstatus(ne);}} id={`opciones_1`} /> 
                                        <Form.Check inline name="group2" type="checkbox" label="MESA DE ATENCIÓN" checked={arreglo_estatus[1]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[1] = e.target.checked;  setEstatus(ne);}} id={`opciones_2`} /> 
                                        <Form.Check inline name="group3" type="checkbox" label="RECTIFICACIÓN" checked={arreglo_estatus[2]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[2] = e.target.checked;  setEstatus(ne);}} id={`opciones_3`} /> 
                                        <Form.Check inline name="group4" type="checkbox" label="VERIFICACIÓN TELEFÓNICA" checked={arreglo_estatus[3]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[3] = e.target.checked;  setEstatus(ne);}} id={`opciones_4`} /> 
                                        <Form.Check inline name="group5" type="checkbox" label="ASEGURAMIENTO" checked={arreglo_estatus[4]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[4] = e.target.checked;  setEstatus(ne);}} id={`opciones_5`} /> 
                                        <Form.Check inline name="group6" type="checkbox" label="VERIFICACIÓN FINAL" checked={arreglo_estatus[5]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[5] = e.target.checked;  setEstatus(ne);}} id={`opciones_6`} /> 
                                        <Form.Check inline name="group7" type="checkbox" label="SIN PAGAR" checked={arreglo_estatus[6]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[6] = e.target.checked;  setEstatus(ne);}} id={`opciones_7`} /> 
                                        <Form.Check inline name="group8" type="checkbox" label="LIQUIDADO" checked={arreglo_estatus[7]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[7] = e.target.checked;  setEstatus(ne);}} id={`opciones_8`} /> 
                                        <Form.Check inline name="group9" type="checkbox" label="PENALIZADO" checked={arreglo_estatus[8]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[8] = e.target.checked;  setEstatus(ne);}} id={`opciones_9`} />
                                        <Form.Check inline name="group10" type="checkbox" label="CANCELADO" checked={arreglo_estatus[9]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[9] = e.target.checked;  setEstatus(ne);}} id={`opciones_10`} />

                                        
                                      </div>

                                      <ul className="list-inline">
                                        <li className="list-inline-item"><small className="cursor" onClick={()=>{todos()}}>Todos</small> / <small className="cursor" onClick={()=>{ninguno()}}>Ninguno</small></li>
                                      </ul>


                          {  (!cargando_ ) && (

                              <>



                                     {
                                       tramites.length > 0 && (

                                         <div key={ Math.random().toString(36).substr(2, 9) } className="mb-4">
                                         

                                <h5>Listado de Trámites</h5>


                            <hr />

                            {
                              // JSON.stringify(User.rol)
                            }

 
 
                                         <div className="table-responsive">

                                              <table className="table table-sm">
                                                <thead>
                                                  <tr>
                                                    <th scope="col">Estatus</th>
                                                    <th scope="col"></th>
                                                    <th scope="col">Cliente</th>
                                                    { ["ROLE_GERENTE","ROLE_GERENTE_JR"].indexOf(User.rol) > -1 && (<th scope="col">Asesor</th>) }
                                                    <th scope="col"></th>
                                                    <th scope="col">Folio</th>
                                                    <th scope="col">Monto Retiro</th>
                                                    <th scope="col"></th>
                                                    <th scope="col"></th>
                                                    <th scope="col"></th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {
                                                    tramites.map( (tramite:any) =>
                                                        <tr key={ Math.random().toString(36).substr(2, 9) }>
                                                          <td className="v text-left cursor" onClick={(e:any)=>{handleShow_ModalFichaTramite(tramite)}} style={{"width":"120px"}}> 
                                                            {
                                                              tramite.idestatus === 1 && (
                                                                  <span onClick={(event)=>{ enviarVerificacion(event,tramite.uuid_tramite) }} className={'badge cursor estatus_'+tramite.idestatus }> {tramite.estatus}</span>
                                                              )
                                                            }
                                                            {
                                                              tramite.idestatus === 2 && (
                                                                  <span  className={'badge estatus_'+tramite.idestatus }> {tramite.estatus}</span>
                                                              )
                                                            }

                                                            {
                                                              tramite.idestatus === 3 && (
                                                                  <span  className={'badge estatus_'+tramite.idestatus }> {tramite.estatus}</span>
                                                              )
                                                            }

                                                            {
                                                              tramite.idestatus === 4 && (
                                                                  <span  className={'badge estatus_'+tramite.idestatus }> {tramite.estatus}</span>
                                                              )
                                                            }

                                                            {
                                                              tramite.idestatus === 5 && (
                                                                  <span onClick={()=>{detalleCobranza(tramite.uuid_tramite)}} className={'badge cursor estatus_'+tramite.idestatus }> {tramite.estatus}</span>
                                                              )
                                                            }

                                                            {
                                                              tramite.idestatus === 6 && (
                                                                  <span  className={'badge estatus_'+tramite.idestatus }> {tramite.estatus}</span>
                                                              )
                                                            }
                                                            {
                                                              tramite.idestatus === 7 && (
                                                                  <span  className={'badge estatus_'+tramite.idestatus }> {tramite.estatus}</span>
                                                              )
                                                            }
                                                            {
                                                              tramite.idestatus === 8 && (
                                                                  <span  className={'badge estatus_'+tramite.idestatus }> {tramite.estatus}</span>
                                                              )
                                                            }
                                                            {
                                                              tramite.idestatus === 9 && (
                                                                  <span  className={'badge estatus_'+tramite.idestatus }> {tramite.estatus}</span>
                                                              )
                                                            }

                                                            {
                                                              tramite.idestatus === 999 && (
                                                                  <span style={{color:'red'}} className={'badge estatus_'+tramite.idestatus }> Cancelada <i className="fa fa-warning" style={{color:'red'}} /></span>
                                                              )
                                                            }
                                                          </td>
                                                          <td className="v text-center" style={{"width":"60px"}}>

                                                            {
                                                              tramite.idestatus === 3 && (
                                                                  <Button className="nm" onClick={()=>{handleShowRectificarModal(tramite.uuid_tramite)}} size="sm" variant="outline-naranja"><i className="fa fa-list" /></Button>
                                                              )
                                                            }


                                                          </td>
                                                          <td className="v text-left" >
                                                              <p className="nm"><small><b>{tramite.nombres}</b></small></p>
                                                              <small>{tramite.paterno} {tramite.materno}</small>
                                                          </td>


                                                            { ["ROLE_GERENTE","ROLE_GERENTE_JR"].indexOf(User.rol) > -1 && (
                                                                <td className="v text-left" style={{width:200}}>
                                                                    <p className="nm"><small><b>{tramite.nombres_asesor}</b></small></p>
                                                                    <small>{tramite.paterno_asesor} {tramite.materno_asesor}</small>
                                                                </td>
                                                              ) }



                                                          <td className="v  text-left" style={{"width":"50px"}}></td>
                                                          {
                                                            // <td className="v no_onmobile text-left" style={{"width":"200px"}}><small>{tramite.paterno}</small></td>
                                                            // <td className="v no_onmobile text-left" style={{"width":"200px"}}><small>{tramite.materno}</small></td>
                                                          }
                                                          <td className="v  text-left" style={{"width":"100px"}}>{tramite.folio}</td>
                                                          <td className="v  text-right" style={{"width":"120px"}}>{formatCurrency(tramite.monto_aseguramiento??0)}</td>
                                                          <td className="v  text-center" style={{"width":"50px"}}>
                                                            {
                                                              (tramite.idestatus === 1 || tramite.idestatus === 3) && (
                                                                  <Button onClick={(e)=>{handleModalAnexosShow(tramite)}} className="nm" size="sm" variant="link"><i className="fa fa-folder" /></Button>
                                                              )
                                                            }
                                                          </td>
                                                          <td className="v text-center" style={{"width":"50px"}}>

                                                            {
                                                              (tramite.idestatus === 1 || tramite.idestatus === 3) && (
                                                                  <Button onClick={(event)=>{editarTramite(event,tramite.uuid_tramite)}} className="nm" size="sm" variant="outline-warning"><i className="fa fa-edit" /></Button>
                                                              )
                                                            }

                                                          
                                                          </td>
                                                          <td className="v text-center" style={{"width":"50px"}}>
                                                            {
                                                              tramite.idestatus === 1 && (
                                                                  <Button onClick={(event)=>{borrarTramite(event,tramite.uuid_tramite)}} className="nm" size="sm" variant="outline-danger"><i className="fa fa-trash" /></Button>
                                                              )
                                                            }
                                                          
                                                          </td>
                                                        </tr>
                                                     )
                                                  }

                                                </tbody>
                                              </table>


                                              <Pagination itemsCount={allSessionsCount} itemsPerPage={sessionsPerPage} currentPage={currentPage} setCurrentPage={setCurrentPage} cambiarPaginaEvento={cargarMiReporte} alwaysShown={false} />


                                             </div>

                                          </div>


                                         )
                                     }


 

                              </>

                           )}

                          {  cargando_ && (

                              <>
                                <div className="loader">
                                  <div className="loaderBar"></div>
                                </div>
                              </>


                           )}








                </div>

                
              </div>

              
            </div>





      {
         showEditarTramite && (
            <EditarTramite show={showEditarTramite} uuid_tramite={uuid_tramite} tramite={data_tramite} departamento={departamento_edicion} mesa_atencion={false} onHide={handleCloseEditarTramite} />
         )
      }










      <Modal show={showRectificarModal} backdrop="static" onHide={()=>setShowRectificarModal(false)} >
        <Modal.Header closeButton>
          <Modal.Title>Rectificar Datos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          

            <p>Comentarios para la Atención del Trámite</p>


            {
              comments.comments.map( (comentario:any,i:number) =>

                        <div key={ Math.random().toString(36).substr(2, 9) } className="card" style={{ margin: '5px 0'}}>
                          <div className="card-body">
                            <h6 className="card-subtitle text-muted"><b>{(i+1)}.-</b> {comentario.tipo_comentario} {comentario.finalizado&&(<i className="fa fa-check-circle" style={{color:"green"}} />)}</h6>
                            <p style={{marginBottom:0}} className="card-text">{comentario.descripcion}</p>
                            {
                              !comentario.finalizado && (
                                  <button type="button" onClick={()=>{comentarioAtendido(comentario.uuid)}} className="btn btn-link"><small>Marca de atendido</small></button>
                              )
                            }
                            
                          </div>
                        </div>

                )
            }

        </Modal.Body>
        {
          comments.resuelto_todo && (
                  <Modal.Footer>
                    <Button variant="primary" onClick={(event)=>{handleCloseRectificarModal(event)}}>
                      Enviar a Mesa de Verificación
                    </Button>
                  </Modal.Footer>
            )
        }

      </Modal>





      <Modal show={showModalAnexos} backdrop="static" size="lg" onHide={handleModalAnexosClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            Anexos Digitales del Trámite
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          


    <Tabs
      id="controlled-tab-example"
      activeKey={key}
      onSelect={(k) => setKey(k)}
      className="mb-3"
    >
      <Tab eventKey="home" title="Anexos">


<div className="form-floating">
  <select className="form-select" value={anexo_visualizar} onChange={(e)=>{ setAnexoVisualizar(e.target.value) }} id="floatingSelect" aria-label="Floating label select example">
  <option disabled={anexo_visualizar===''?false:true} value="">Selecciona una opción</option>
    {
      anexos_tramite_seleccionado.anexos_digitales.map( anexo =>

          <option key={ Math.random().toString(36).substr(2, 9) } value={anexo.uuid} >
            {
              (anexo.idrequisito.requisito)
            }
          </option>

      )
    }
  </select>
  <label htmlFor="floatingSelect">Anexo para visualizar</label>
</div>


<br />


{
  anexo_visualizar != "" && (
    <React.Fragment>
      <object width="100%" height="700px" data={SERVER_+'anexo/'+anexo_visualizar} type="application/pdf">
          <p>This browser does not support PDFs. Please download the PDF to view it: <a href="filename.pdf">Download PDF</a>.</p>
      </object>

<ul className="list-group list-group-flush">
  <li className="list-group-item">
      <button type="button" onClick={()=>{eliminarAnexo(anexo_visualizar)}} className="btn btn-link"><i className="fa fa-trash" /> Eliminar Anexo</button>
  </li>
</ul>
    </React.Fragment>
  )
}



            {
              // JSON.stringify(anexos_tramite_seleccionado)
            }
      </Tab>
      <Tab eventKey="profile" title="Carga de Anexos">

          <h5>Cargar un Anexo del Trámite</h5>

<div className="form-floating">
  <select className="form-select" id="floatingSelect" value={anexo_para_subir} onChange={(e)=>{ setAnexoSubir(e.target.value) }} aria-label="Anexos que puede subir:">
    <option disabled={anexo_para_subir===''?false:true} value="">Selecciona una opción</option>
    {
      anexos_tramite_seleccionado.anexos_por_subir.map( anexo =>
          <option key={ Math.random().toString(36).substr(2, 9) } value={anexo.uuid_requisito} >
            {
              (anexo.requisito)
            }
          </option>
      )
    }
  </select>
  <label htmlFor="floatingSelect">Anexos que puede subir:</label>
</div>


<div className="mt-4 mb-4">
  <label htmlFor="formFileLg" className="form-label">Archivo para subir</label>
  <input className="form-control form-control-lg" id="formFileLg" type="file" accept="application/pdf" onChange={(event)=>{ handleFileRead(event); }} />
</div>

{
  // JSON.stringify(anexo_archivo_subir)

  anexo_archivo_subir !== '' && (

    <object data={anexo_archivo_subir} type="application/pdf" width="100%" height="900">
      <p>It appears you don't have a PDF plugin for this browser.
      No biggie... you can <a href="http://www.example.com/the.pdf">click here to
      download the PDF file.</a></p>
    </object>
)

}


<div className="d-grid gap-2 mt-2">
  <button className="btn btn-primary" onClick={(e)=>{agregarNuevoAnexo()}} disabled={anexo_archivo_subir===''||anexo_para_subir===''} type="button">AGREGAR ANEXO</button>
</div>





      </Tab>
    </Tabs>



        </Modal.Body>
      </Modal>







      <Modal
        show={showPendientesModal}
        onHide={handleClosePendientesModal}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Fechas con Trámites Pendientes</Modal.Title>
        </Modal.Header>
        <Modal.Body>

            <p>Listado de Trámites Pendientes de gestión</p>

            {
              // JSON.stringify(fechas_tramites_pendientes)
            }

            <table className="table">
              <thead style={{fontSize:10}}>
                <tr>
                  <th scope="col">Fecha</th>
                  <th scope="col">Total</th>
                  <th scope="col">Captura</th>
                  <th scope="col">Rectificación</th>
                  <th scope="col">Cobranza</th>
                </tr>
              </thead>
              <tbody style={{fontSize:12}}>
              {
                fechas_tramites_pendientes.map( fecha =>

                      <tr key={ Math.random().toString(36).substr(2, 9) }>
                        <th className="v" scope="row">
                          {fecha.fecha_tramite}
                        </th>
                        <td className="v">
                          <b>{fecha.cantidad}</b>
                        </td>
                        <td className="v" style={{width:60}}>{fecha.en_captura}</td>
                        <td className="v" style={{width:60}}>{fecha.en_rectificacion}</td>
                        <td className="v" style={{width:60}}>{fecha.no_cobrado}</td>
                        <td className="v" style={{width:60}}>
                          <button onClick={()=>{irAFecha(fecha.fecha_tramite)}} type="button" className="btn btn-sm btn-link"><i className="fa fa-eye" /></button>
                        </td>
                      </tr>


                  )
              }

              </tbody>
            </table>

        </Modal.Body>
      </Modal>






  {
    show_ModalFichaTramite && (
      <ModalFichaTramite show={show_ModalFichaTramite} handleClose={handleClose_ModalFichaTramite} tramite={tramite_seleccionado} />
      )

  }


          </>

      );
  

}

export default MisTramites
